/* brain-chat.js — on-site chat bubble. Loaded by snippets/brain-chat.liquid.
 * Talks ONLY to the brain endpoint set in data-endpoint; product links stay on
 * this host; add-to-cart uses the theme's own /cart/add.js so the drawer/cart
 * page the customer already sees is the cart that changes. No cookies: the
 * session id lives in sessionStorage and is opaque to the server. */
(function () {
  'use strict';
  var root = document.getElementById('brain-chat');
  if (!root || window.__brainChatBooted) return;
  window.__brainChatBooted = true;

  var ENDPOINT = root.getAttribute('data-endpoint');
  var STORE = root.getAttribute('data-store');
  var THEME = root.getAttribute('data-theme') || (STORE === 'store2' ? 'game7' : 'cruces');
  var NAME = root.getAttribute('data-name') || 'Chat';
  var BRAND = root.getAttribute('data-brand') || '';
  var GREETING = root.getAttribute('data-greeting') || 'Hey! What can I help you find?';
  var IS_G7 = THEME === 'game7' || STORE === 'store2';

  // Per-store chrome — same engine, different face. Never share footer/header copy.
  var SUBTITLE = IS_G7 ? 'Game 7 AI help' : 'cruces shop ai';
  var FOOT = IS_G7
    ? 'AI help · email mike@game7online.com for a person'
    : 'shop ai · email service@crucesclothing.com for a person';
  var PLACEHOLDER = IS_G7
    ? 'Ask about a hat, sizing, or your order…'
    : 'hat, size, or order — ask away';
  var SEND_LABEL = IS_G7 ? 'Send' : 'go';
  var CHIPS = IS_G7
    ? [
        { label: 'Where is my order?', send: 'Where is my order?' },
        { label: 'Help with sizing', send: 'I need help picking a size' },
        { label: 'Shipping & exchanges', send: 'What are your shipping and return policies?' }
      ]
    : [
        { label: 'track my order', send: 'Track my order' },
        { label: 'sizing', send: 'I need help picking a size' },
        { label: 'shipping / returns', send: 'What are your shipping and return policies?' }
      ];
  var MAX_MSG = 500;

  function sid() {
    try {
      var k = 'brainChatSession';
      var v = sessionStorage.getItem(k);
      if (!v) {
        var a = new Uint8Array(16); (window.crypto || window.msCrypto).getRandomValues(a);
        v = 's_' + Array.prototype.map.call(a, function (b) { return ('0' + b.toString(16)).slice(-2); }).join('');
        sessionStorage.setItem(k, v);
      }
      return v;
    } catch (e) { return 's_' + Math.random().toString(16).slice(2) + Date.now().toString(16); }
  }
  var SESSION = sid();
  var history = [];
  try { history = JSON.parse(sessionStorage.getItem('brainChatLog') || '[]'); } catch (e) { history = []; }
  function persist() { try { sessionStorage.setItem('brainChatLog', JSON.stringify(history.slice(-30))); } catch (e) {} }

  function el(tag, cls, text) { var n = document.createElement(tag); if (cls) n.className = cls; if (text != null) n.textContent = text; return n; }

  // ── DOM ───────────────────────────────────────────────────────────────
  var bubble = el('button', 'bc-bubble');
  bubble.setAttribute('aria-label', 'Open chat');
  // Different bubble icons: Cruces = simple chat, Game 7 = filled sports-ish chat
  bubble.innerHTML = IS_G7
    ? '<svg width="26" height="26" viewBox="0 0 24 24" fill="currentColor"><path d="M4 4h16a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H8l-4 3V6a2 2 0 0 1 2-2z"/></svg>'
    : '<svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 12a8 8 0 0 1-8 8H8l-5 3 1.5-4.5A8 8 0 1 1 21 12z"/></svg>';
  var panel = el('section', 'bc-panel');
  panel.setAttribute('role', 'dialog'); panel.setAttribute('aria-label', NAME + ' chat');
  var head = el('header', 'bc-head');
  var hname = el('div', 'bc-hname'); hname.appendChild(el('b', null, NAME)); hname.appendChild(el('span', null, SUBTITLE));
  var close = el('button', 'bc-close', '×'); close.setAttribute('aria-label', 'Close chat');
  head.appendChild(hname); head.appendChild(close);
  var log = el('div', 'bc-log'); log.setAttribute('aria-live', 'polite');
  var chips = el('div', 'bc-chips');
  var form = el('form', 'bc-form');
  var input = el('input', 'bc-input'); input.type = 'text'; input.placeholder = PLACEHOLDER; input.maxLength = MAX_MSG; input.autocomplete = 'off';
  var send = el('button', 'bc-send', SEND_LABEL); send.type = 'submit';
  form.appendChild(input); form.appendChild(send);
  var foot = el('div', 'bc-foot', FOOT);
  panel.appendChild(head); panel.appendChild(log); panel.appendChild(chips); panel.appendChild(form); panel.appendChild(foot);
  root.appendChild(bubble); root.appendChild(panel);

  // ── rendering ─────────────────────────────────────────────────────────
  function addMsg(role, text, cards) {
    var m = el('div', 'bc-msg bc-' + role);
    var b = el('div', 'bc-body');
    var parts = String(text).split(/(https?:\/\/[^\s)]+)/g);
    for (var i = 0; i < parts.length; i++) {
      var p = parts[i];
      if (/^https?:\/\//.test(p)) {
        var ok = false; try { ok = new URL(p).host === location.host || new URL(p).host.replace(/^www\./, '') === location.host.replace(/^www\./, ''); } catch (e) {}
        if (ok) { var a = el('a', null, 'open'); a.href = p; a.target = '_self'; b.appendChild(a); }
        else b.appendChild(document.createTextNode(p));
      } else b.appendChild(document.createTextNode(p));
    }
    m.appendChild(b);
    if (cards && cards.length) {
      var row = el('div', 'bc-cards');
      cards.forEach(function (c) { row.appendChild(card(c)); });
      m.appendChild(row);
    }
    log.appendChild(m);
    log.scrollTop = log.scrollHeight;
    return m;
  }
  function card(c) {
    var w = el('div', 'bc-card');
    var a = el('a', 'bc-cimg'); a.href = c.path; if (c.image) { var img = el('img'); img.src = c.image; img.alt = c.title; img.loading = 'lazy'; a.appendChild(img); }
    var t = el('a', 'bc-ctitle', c.title); t.href = c.path;
    var pr = el('div', 'bc-cprice', c.price);
    w.appendChild(a); w.appendChild(t); w.appendChild(pr);
    if (c.sizes && c.sizes.length) {
      var ctl = el('div', 'bc-cadd');
      var sel = el('select', 'bc-csel');
      c.sizes.forEach(function (s) { var o = el('option', null, s.label); o.value = s.variant_id; sel.appendChild(o); });
      var btn = el('button', 'bc-cbtn', c.sizes.length === 1 && /snap|one size/i.test(c.sizes[0].label) ? 'Add to cart' : 'Add');
      btn.type = 'button';
      if (c.sizes.length === 1 && /snap|one size/i.test(c.sizes[0].label)) sel.style.display = 'none';
      btn.addEventListener('click', function () { addToCart(sel.value, btn); });
      ctl.appendChild(sel); ctl.appendChild(btn); w.appendChild(ctl);
    } else {
      w.appendChild(el('div', 'bc-csold', 'Sold out'));
    }
    return w;
  }
  function addToCart(variantId, btn) {
    btn.disabled = true; var was = btn.textContent; btn.textContent = '…';
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] }) })
      .then(function (r) { if (!r.ok) throw new Error('cart'); return r.json(); })
      .then(function () {
        btn.textContent = 'Added ✓';
        addMsg('bot', IS_G7 ? 'Added to your cart.' : 'in your cart.');
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        try { if (window.Shopify && window.Shopify.onCartUpdate) window.Shopify.onCartUpdate(); } catch (e) {}
        var drawer = document.querySelector('cart-drawer, #CartDrawer');
        if (drawer && typeof drawer.open === 'function') { fetch('/cart?section_id=cart-drawer').then(function (r) { return r.text(); }).then(function (html) {
          try { var doc = new DOMParser().parseFromString(html, 'text/html'); var fresh = doc.querySelector('cart-drawer, #CartDrawer'); if (fresh) drawer.innerHTML = fresh.innerHTML; } catch (e) {}
          drawer.open();
        }); }
        setTimeout(function () { btn.disabled = false; btn.textContent = was; }, 2500);
      })
      .catch(function () { btn.disabled = false; btn.textContent = was; addMsg('bot', IS_G7 ? "Couldn't add that just now — open the product and add it from there." : "couldn't add that — open the product page and try from there."); });
  }
  function typing(on) {
    var t = log.querySelector('.bc-typing');
    if (on && !t) { t = el('div', 'bc-msg bc-bot bc-typing'); t.innerHTML = '<span></span><span></span><span></span>'; log.appendChild(t); log.scrollTop = log.scrollHeight; }
    if (!on && t) t.remove();
  }
  function renderChips() {
    chips.innerHTML = '';
    CHIPS.forEach(function (c) { var b = el('button', 'bc-chip', c.label); b.type = 'button'; b.addEventListener('click', function () { ask(c.send); }); chips.appendChild(b); });
  }

  // ── transport ─────────────────────────────────────────────────────────
  var busy = false;
  function ask(text) {
    text = String(text || '').trim().slice(0, MAX_MSG);
    if (!text || busy) return;
    busy = true; send.disabled = true; chips.style.display = 'none';
    addMsg('user', text); history.push({ r: 'user', t: text }); persist();
    typing(true);
    fetch(ENDPOINT, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ store: STORE, session_id: SESSION, message: text, page: location.pathname }) })
      .then(function (r) { return r.json().then(function (j) { j.__status = r.status; return j; }); })
      .then(function (j) {
        typing(false);
        if (!j.ok) {
          var msg = j.__status === 429
            ? (IS_G7 ? "You're sending a lot of messages — give it a few minutes, or email us." : "slow down a sec — or just email the shop.")
            : (IS_G7 ? 'Chat is briefly unavailable. Email us and a person will get back to you.' : 'chat is down for a minute — email the shop and a person will hit you back.');
          addMsg('bot', msg); return;
        }
        addMsg('bot', j.reply, j.cards); history.push({ r: 'bot', t: j.reply, c: j.cards || [] }); persist();
        if (j.handed_off) { foot.textContent = IS_G7 ? 'Passed to Mike — check your email' : 'handed to marcus — check your email'; }
        if (j.turns_left === 0) { input.disabled = true; input.placeholder = IS_G7 ? 'Continue by email' : 'keep going over email'; }
      })
      .catch(function () { typing(false); addMsg('bot', IS_G7 ? 'Connection hiccup — try again in a moment.' : 'connection blip — try again.'); })
      .then(function () { busy = false; send.disabled = false; input.focus(); });
  }
  form.addEventListener('submit', function (e) { e.preventDefault(); var t = input.value; input.value = ''; ask(t); });

  function liftAbovePreviewBar() {
    var bar = document.getElementById('PBarNextFrameWrapper') || document.getElementById('preview-bar-iframe');
    var h = bar ? Math.ceil(bar.getBoundingClientRect().height) : 0;
    root.style.setProperty('--bc-lift', h + 'px');
  }
  liftAbovePreviewBar();
  setTimeout(liftAbovePreviewBar, 1500);
  window.addEventListener('resize', liftAbovePreviewBar);

  /* Keep the bubble off the storefront's own CTAs. Game 7's homepage puts a full-width red
   * "SHOP ALL ..." button under every collection strip, and a fixed bubble parked in the corner
   * lands right on top of one at some scroll positions (owner report 2026-09-03). Rather than
   * guess a safe offset, ask the page what is actually under the bubble and step over it.
   * elementFromPoint is used instead of IntersectionObserver because the CTA that matters is
   * whichever one happens to be beneath the bubble right now, not one we can subscribe to. */
  /* Geometry, not selectors. The first version matched a class list ('.button', 'button', ...)
   * and missed Game 7's actual offender, <a class="sb-cat__cta">, so it never fired. It also relied
   * on elementsFromPoint, which reports Shopify's cookie-consent banner instead of the CTA beneath
   * it. What we actually care about is simpler and theme-independent: is there a WIDE tappable band
   * (any link/button spanning a good chunk of the viewport) sitting under the bubble? If so, sit
   * above it. */
  var DODGE_MIN_WIDTH_RATIO = 0.4;   // a "CTA band" spans at least 40% of the viewport
  var DODGE_MIN_HEIGHT = 28;
  var dodgePending = false;
  /* While the cart drawer (or any modal) is open the bubble has nowhere good to sit: dodging the
   * CHECK OUT button just parks it on the protection row instead. Every other chat widget hides in
   * this situation, so do that — it removes the whole class of collisions inside the drawer. */
  var MODAL_SELECTOR = 'dialog[open], cart-drawer.active, cart-drawer[open], .drawer.active, .cart-drawer.active, .modal.active, [aria-modal="true"]';
  /* Dawn keeps its drawers and search modal in the DOM permanently with aria-modal="true" and a
   * non-zero box, so "matches the selector and has a size" hushed the bubble on every page load
   * (Cruces, 2026-09-03). A modal only counts when it is actually painted AND owns most of the
   * screen — that is the only case where the bubble has nowhere to sit. */
  function modalOpen() {
    var nodes = document.querySelectorAll(MODAL_SELECTOR);
    var vw = window.innerWidth, vh = window.innerHeight;
    for (var i = 0; i < nodes.length; i++) {
      var n = nodes[i];
      if (root.contains(n)) continue;                        // our own panel does not count
      var cs = window.getComputedStyle(n);
      if (cs.visibility === 'hidden' || cs.display === 'none' || parseFloat(cs.opacity) < 0.1) continue;
      var r = n.getBoundingClientRect();
      if (r.width < vw * 0.5 || r.height < vh * 0.4) continue;   // a strip is not an overlay
      if (r.bottom <= 0 || r.top >= vh) continue;                // parked off-screen
      return true;
    }
    return false;
  }

  function dodgeCTAs() {
    dodgePending = false;
    if (modalOpen()) { root.classList.add('bc-hushed'); return; }
    root.classList.remove('bc-hushed');
    if (root.classList.contains('bc-open')) { root.style.setProperty('--bc-dodge', '0px'); return; }
    // Measure from the undodged position so the result never depends on the previous frame.
    root.style.setProperty('--bc-dodge', '0px');
    var base = bubble.getBoundingClientRect();
    if (!base.width) return;
    var vw = window.innerWidth, vh = window.innerHeight;
    var minW = vw * DODGE_MIN_WIDTH_RATIO;
    var nodes = document.querySelectorAll('a,button,[role="button"],[type="submit"]');
    var best = null;
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      if (root.contains(el)) continue;
      var r = el.getBoundingClientRect();
      if (r.width < minW || r.height < DODGE_MIN_HEIGHT) continue;
      if (r.bottom < base.top || r.top > base.bottom) continue;      // no vertical overlap
      if (r.right < base.left || r.left > base.right) continue;      // no horizontal overlap
      if (!best || r.top < best.top) best = r;                       // clear the highest one
    }
    if (!best) return;
    var lift = Math.ceil(vh - best.top) + 12;
    lift = Math.min(lift, Math.max(0, vh - base.height - 24));        // never leave the viewport
    root.style.setProperty('--bc-dodge', (lift > 0 ? lift : 0) + 'px');
  }
  function queueDodge() {
    if (dodgePending) return;
    dodgePending = true;
    setTimeout(dodgeCTAs, 200);
  }
  window.addEventListener('scroll', queueDodge, { passive: true });
  window.addEventListener('resize', queueDodge);
  // Opening the cart drawer puts a pinned CHECK OUT button under the bubble without firing a single
  // scroll or resize event, so those two listeners alone left the bubble sitting on the checkout CTA
  // (owner report 2026-09-03). Watch the DOM as well; dodgeCTAs is debounced and cheap enough.
  var dodgeObserver = new MutationObserver(queueDodge);
  try {
    dodgeObserver.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'open', 'style', 'aria-hidden'] });
  } catch (err) {}
  document.addEventListener('click', queueDodge, true);
  queueDodge();
  setTimeout(queueDodge, 1600);

  var opened = false;
  function open() {
    liftAbovePreviewBar();
    root.classList.add('bc-open'); bubble.setAttribute('aria-expanded', 'true');
    if (!opened) {
      opened = true;
      if (history.length) { history.forEach(function (h) { addMsg(h.r, h.t, h.c); }); }
      else addMsg('bot', GREETING);
      renderChips();
      if (history.length) chips.style.display = 'none';
    }
    setTimeout(function () { input.focus(); }, 50);
  }
  function shut() { root.classList.remove('bc-open'); bubble.setAttribute('aria-expanded', 'false'); }
  bubble.addEventListener('click', function () { root.classList.contains('bc-open') ? shut() : open(); });
  close.addEventListener('click', shut);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && root.classList.contains('bc-open')) shut(); });
  if (/[?&]chat=open/.test(location.search) || location.hash === '#chat') open();
})();
